<template>
	<div>
		<section-entity
			v-for="(otherHolder, i) in otherHoldersSection"
			:key="i"
			:componentProps="otherHolder.componentProps"
			:componentHandlers="otherHolder.componentHandlers"
			:sectionTitle="sectionTitle"
			:removable="true"
			:showButtons="showButtons"
			v-on="otherHolder.sectionHandlers"
			class="bg5"
		/>
	</div>
</template>

<script>
import SectionEntity from "../SectionEntity"

export default {
	name: "SectionOtherHolders",
	components: {
		SectionEntity
	},
	props: {
		otherHoldersSection: {
			type: Array
		},
		showButtons: {
			required: false,
			default: true
		}
	},

	data() {
		return {
			sectionTitle: this.$t("holder")
		}
	},

	methods: {}
}
</script>
